import styled from "styled-components";
import { TransitionGroup } from "react-transition-group";
export var StyledTransitionGroup = /*#__PURE__*/ styled(TransitionGroup).withConfig({
  displayName: "NotificationStackstyle__StyledTransitionGroup"
})([""]);
